<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Trips</translate></template>
            <template v-slot:buttons>
                <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_trips'" /> -->
                <GekkoButton 
                    @click="addTrip" 
                    :text="$gettext('New')" 
                    icon="fa-solid fa-plus"
                    class="mr-2"
                />
                <GekkoButton 
                    @click="download" 
                    :text="$gettext('Download')" 
                    icon="fa-solid fa-download"
                    variant="outline-primary"
                />
            </template>
        </TitleBar>
        <div class="content">
            <TripTable />
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import TripTable from "@/components/trips/TripTable"
import GekkoButton from "@/components/GekkoButton";
import TripService from "@/store/services/trip.service";
import { mapGetters } from "vuex"
// import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

export default {
    name: 'Trips',
    components: { 
        TitleBar, 
        TripTable, 
        GekkoButton,
        // OnboardingIntroLink
    },
    data() {
        return {
            
        }
    },
    computed: {
        ...mapGetters({
            visitingCompanyId: 'main/getVisitingCompanyId'
        })
    },
    methods: {
        addTrip() {
            this.$router.push({name: 'AddTrip'});
        },
        download() {
            let filters = this.$store.getters['filterStore/getFilter'];
            filters['company_profile'] = this.visitingCompanyId;
            TripService.exportTrips(filters).then(() => {
                let alert_text = this.$gettext("You will receive an email with your download URL as soon as your export is ready.");
                this.$store.commit('setAlert', {title: this.$gettext("Trip Download"), text: alert_text, variant:"info", duration:4});
            }).catch(() => {
                this.$store.commit('setAlert', {title: this.$gettext("Error"), text: this.$gettext("An error occurred while exporting your trips."), variant:"danger", duration:4});
            });
        },
        encodeQueryData(data) {
            var ret = [];
            for (var d in data)
                if (data[d]) {
                    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
                }
            return ret.join("&");
        }
    }
}
</script>

<style scoped>

</style>